import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/home/Home.vue'
import Activity from '../views/activity/Activity.vue'
import News from '../views/news/News.vue'
import Mine from '../views/mine/Mine.vue'
import Artdea from '../views/home/Artdea.vue'
import Artlist from '../views/home/Artlist.vue'
import Lame from '../views/home/Lame.vue'
import Lamedea from '../views/home/Lamedea.vue'
import noticedea from '../views/news/noticedea.vue'
import Actiday from '../views/home/Actiday.vue'
import Activdea from '../views/activity/Activdea.vue'
import Feedback from '../views/activity/Feedback.vue'
import Basicdata from '../views/mine/Basicdata.vue'
import Identity from '../views/mine/Identity.vue'
import Join from '../views/home/Join.vue'
import MeJoin from '../views/home/MeJoin.vue'
import Joindea from '../views/home/Joindea.vue'
import Enterlist from '../views/home/Enterlist.vue'
import Enterdea from '../views/home/Enterdea.vue'
import Signday from '../views/home/Signday.vue'
import Mysign from '../views/mine/Mysign.vue'
import Signdea from '../views/mine/Signdea.vue'
import Myintegral from '../views/mine/Myintegral.vue'
import Myexchange from '../views/mine/Myexchange.vue'
import Exchangedea from '../views/mine/Exchangedea.vue'
import Integral from '../views/mine/Integral.vue'
import Exchange from '../views/home/Exchange.vue'
import Exchangdea from '../views/home/Exchangdea.vue'
import Speedlist from '../views/home/Speedlist.vue'
import Speeddea from '../views/home/Speeddea.vue'
import Basicd from '../views/mine/Basicd.vue'
import Ident from '../views/mine/Ident.vue'
import Service from '../views/mine/Service.vue'
import Persinfo from '../views/mine/Persinfo.vue'
import Steup from '../views/mine/Steup.vue'
import Sign from '../views/mine/Sign.vue'
import Register from '../views/mine/Register.vue'
import Setphone from '../views/mine/Setphone.vue'
import Setpassword from '../views/mine/Setpassword.vue'
import Member from '../views/mine/Member.vue'
import Myspeed from '../views/mine/Myspeed.vue'
import Myformal from '../views/mine/Myformal.vue'
import Forspeed from '../views/mine/Forspeed.vue'
import Foracti from '../views/mine/Foracti.vue'
import Train from '../views/mine/Train.vue'
import ranking from '../views/home/Ranking.vue'
import rankdea from '../views/home/Rankdea.vue'
import rankingPersonnel from '../views/home/RankingPersonnel.vue'
import rankdeaPersonnel from '../views/home/RankdeaPersonnel.vue'
import rankdeaIntegral from '../views/home/RankdeaIntegral.vue'
import ApplyCertificate from '../views/home/ApplyCertificate.vue'
import download from '../views/bank/download.vue'
import ToWeApp from '../views/mine/ToWeApp.vue'

Vue.use(Router)

// 解决跳转到当前路由报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err)
}

export default new Router({
    mode: 'history', // 去掉url中的#
    base: '/h5/',
    routes: [{
        path: '/',
        name: 'Home',
        component: Home,
    }, {
        path: '/activity',
        name: 'Activity',
        component: Activity,
    }, {
        path: '/news',
        name: 'News',
        component: News,
    }, {
        path: '/mine',
        name: 'Mine',
        component: Mine,
    }, {
        path: '/home/Artdea',
        name: 'Artdea',
        component: Artdea,
    }, {
        path: '/home/Artlist',
        name: 'Artlist',
        component: Artlist,
    }, {
        path: '/home/Lame',
        name: 'Lame',
        component: Lame,
    }, {
        path: '/home/Actiday',
        name: 'Actiday',
        component: Actiday,
    }, {
        path: '/activity/Activdea',
        name: 'Activdea',
        component: Activdea,
    }, {
        path: '/activity/Feedback',
        name: 'Feedback',
        component: Feedback,
    }, {
        path: '/mine/Basicdata',
        name: 'Basicdata',
        component: Basicdata,
    }, {
        path: '/mine/Identity',
        name: 'Identity',
        component: Identity,
    }, {
        path: '/home/Join',
        name: 'Join',
        component: Join,
    }, {
        path: '/home/MeJoin',
        name: 'MeJoin',
        component: MeJoin,
    }, {
        path: '/home/Joindea',
        name: 'Joindea',
        component: Joindea,
    }, {
        path: '/home/Enterlist',
        name: 'Enterlist',
        component: Enterlist,
    }, {
        path: '/home/Enterdea',
        name: 'Enterdea',
        component: Enterdea,
    }, {
        path: '/home/Speedlist',
        name: 'Speedlist',
        component: Speedlist,
    }, {
        path: '/home/Speeddea',
        name: 'Speeddea',
        component: Speeddea,
    }, {
        path: '/home/Signday',
        name: 'Signday',
        component: Signday,
    }, {
        path: '/mine/Mysign',
        name: 'Mysign',
        component: Mysign,
    }, {
        path: '/mine/Signdea',
        name: 'Signdea',
        component: Signdea,
    }, {
        path: '/mine/Myintegral',
        name: 'Myintegral',
        component: Myintegral,
    }, {
        path: '/mine/Myexchange',
        name: 'Myexchange',
        component: Myexchange,
    }, {
        path: '/mine/Exchangedea',
        name: 'Exchangedea',
        component: Exchangedea,
    }, {
        path: '/mine/Integral',
        name: 'Integral',
        component: Integral,
    }, {
        path: '/home/Exchange',
        name: 'Exchange',
        component: Exchange,
    }, {
        path: '/home/Exchangdea',
        name: 'Exchangdea',
        component: Exchangdea,
    }, {
        path: '/mine/Basicd',
        name: 'Basicd',
        component: Basicd,
    }, {
        path: '/mine/Ident',
        name: 'Ident',
        component: Ident,
    }, {
        path: '/mine/Service',
        name: 'Service',
        component: Service,
    }, {
        path: '/mine/Persinfo',
        name: 'Persinfo',
        component: Persinfo,
    }, {
        path: '/mine/Steup',
        name: 'Steup',
        component: Steup,
    }, {
        path: '/mine/Sign',
        name: 'Sign',
        component: Sign,
    }, {
        path: '/mine/Register',
        name: 'Register',
        component: Register,
    }, {
        path: '/mine/Setphone',
        name: 'Setphone',
        component: Setphone,
    }, {
        path: '/mine/Setpassword',
        name: 'Setpassword',
        component: Setpassword,
    }, {
        path: '/mine/Member',
        name: 'Member',
        component: Member,
    }, {
        path: '/mine/Myspeed',
        name: 'Myspeed',
        component: Myspeed,
    }, {
        path: '/mine/Myformal',
        name: 'Myformal',
        component: Myformal,
    }, {
        path: '/mine/Forspeed',
        name: 'Forspeed',
        component: Forspeed,
    }, {
        path: '/mine/Foracti',
        name: 'Foracti',
        component: Foracti,
    },
    {
        path: '/mine/Train',
        name: 'Train',
        component: Train,
    }, {
    path: '/home/Lamedea',
    name: 'Lamedea',
    component: Lamedea,
    }, {
        path: '/news/noticedea',
        name: 'noticedea',
        component: noticedea,
    }, {
        path: '/home/rankdea',
        name: 'rankdea',
        component: rankdea,
    }, {
        path: '/home/ranking',
        name: 'ranking',
        component: ranking,
    }, {
        path: '/home/rankingPersonnel',
        name: 'rankingPersonnel',
        component: rankingPersonnel,
    }, {
        path: '/home/rankdeaPersonnel',
        name: 'rankdeaPersonnel',
        component: rankdeaPersonnel,
    }, {
        path: '/home/rankdeaIntegral',
        name: 'rankdeaIntegral',
        component: rankdeaIntegral,
    }, {
        path: '/mine/ApplyCertificate',
        name: 'ApplyCertificate',
        component: ApplyCertificate,
    },
        {
            path: '/download',
            name: 'download',
            component: download,
        },
        {
            path: '/mine/ToWeApp',
            name: 'ToWeApp',
            component: ToWeApp,
        }
    ],
    // 跳转页面回到顶端
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {
                x: 0,
                y: 0
            }
        }
    }
})
